import { type TagBadgeColour, resolveTagBadgeColourSwatch } from '@/shared/data/tagBadgeColours';
import { alpha } from '@/ui/primitives/colorUtils';

export type LightTagBadgeStyle = {
  backgroundColor: string;
  borderColor: string;
  color: string;
};

const lightTagBadgeStyles = {
  neutral: {
    backgroundColor: '#eceff3',
    borderColor: alpha('#59616d', 0.34),
    color: '#4c545f',
  },
  green: {
    backgroundColor: '#e1f2e5',
    borderColor: alpha('#2f7d46', 0.36),
    color: '#246d39',
  },
  orange: {
    backgroundColor: '#f6e8d2',
    borderColor: alpha('#9a620f', 0.36),
    color: '#80500d',
  },
  red: {
    backgroundColor: '#f7e2e0',
    borderColor: alpha('#a04a46', 0.36),
    color: '#873d39',
  },
  blue: {
    backgroundColor: '#e0eef7',
    borderColor: alpha('#2c7196', 0.36),
    color: '#245f80',
  },
  purple: {
    backgroundColor: '#ece6f7',
    borderColor: alpha('#6b55a3', 0.36),
    color: '#5b488d',
  },
  teal: {
    backgroundColor: '#ddf3f2',
    borderColor: alpha('#007c7a', 0.36),
    color: '#006d6b',
  },
  brown: {
    backgroundColor: '#eee8e5',
    borderColor: alpha('#6b5a52', 0.36),
    color: '#5b4b44',
  },
} as const satisfies Record<TagBadgeColour, LightTagBadgeStyle>;

export const resolveLightTagBadgeStyle = (colour: TagBadgeColour): LightTagBadgeStyle =>
  lightTagBadgeStyles[colour];

export const resolveDarkTagBadgeStyle = (colour: TagBadgeColour): LightTagBadgeStyle => {
  const swatch = resolveTagBadgeColourSwatch(colour);
  return {
    backgroundColor: swatch,
    borderColor: 'transparent',
    color: '#ffffff',
  };
};
